import React from 'react';
import SearchSummary from '../../../reportPage/middleContainer/sections/search/components/SearchSummary';

/**
 * Thin wrapper that renders the AI Summary for the unified Sources-panel search (M6A).
 *
 * The underlying {@link SearchSummary} reads `searchId` from {@link useReportStore} — which the
 * unified search hook populates from the `X-Search-Id` response header — and renders nothing
 * until a summary-bearing search id exists. Rendered above the unified search results.
 */
export default function UnifiedSearchSummary() {
    return <SearchSummary/>;
}
